import React from 'react';
import ErrorBoundary from './ErrorBoundary';

export default function withErrorBoundary(
  InnerComponent,
  OuterComponent = undefined
) {
  return function ComponentWithErrorBoundary(props) {
    return (
      <ErrorBoundary location={props.location} container={OuterComponent}>
        <InnerComponent {...props} />
      </ErrorBoundary>
    );
  };
}
